import { SingleTierTax } from './../../classes/singleTierTax/singleTierTax';
import { rates } from './config';
import { EigenWoningForfaitConfig } from './interface';

export class EigenWoningForfait {
    
    tax: number;
    
    constructor(data: EigenWoningForfaitConfig) {
        this.tax = new SingleTierTax(rates[data.year], data.houseValue).tax;
    }
    
}
